<template>
  <v-dialog
    v-model="dialog.open"
    class="discount-dialog"
    :width="isMobile ? 'auto' : '530'"
    :fullscreen="isMobile"
    :scrollable="isMobile"
    @click:outside="closeDialog"
  >
    <v-card class="dialog-discount dialog-card">
      <v-card-title class="dialog-header">
        新增優惠
        <i
          class="close icon-close"
          @click="closeDialog"
        />
      </v-card-title>
      <v-card-text class="dialog-content">
        <v-tabs
          v-model="tabs"
          fixed-tabs
          class="tabs"
        >
          <v-tab class="tab">
            一般兌換
          </v-tab>
          <v-tab class="tab">
            企業夥伴兌換
          </v-tab>
          <v-tabs-items v-model="tabs">
            <!-- 一般兌換tab -->
            <v-tab-item class="receive-tab-content">
              <div class="receice-content content-wrap">
                <v-text-field
                  v-model="common.couponSn"
                  label="請輸入優惠代碼"
                  single-line
                  outlined
                  :clearable="Boolean(common.couponSn) && common.couponSnFocus"
                  :success-messages="common.successMessages"
                  :error-messages="common.errorMessages"
                  type="text"
                  @focus="common.couponSnFocus = true"
                  @blur="common.couponSnFocus = false"
                  @click:clear="clearTextHandle('common')"
                />
                <div
                  v-if="common.receivedCoupon && common.discount.type === 'Bonus'"
                  class="item"
                >
                  <img
                    src="~/assets/image/bonus.svg"
                    alt="紅利點數"
                  >
                  <div class="content">
                    <p class="desc">
                      恭喜您獲得紅利點數<span class="price">{{ common.discount.bonus.total }}</span>點
                    </p>
                  </div>
                </div>
                <div
                  v-if="common.receivedCoupon && common.discount.type === 'Ticket'"
                  class="item"
                >
                  <img
                    src="~/assets/image/ticket.svg"
                    alt="優惠券"
                  >
                  <div class="content">
                    <p class="label">
                      優惠券
                    </p>
                    <p class="desc">
                      恭喜您獲得優惠券<span class="price">{{ common.discount.ticket.list.length }}</span>張
                    </p>
                  </div>
                </div>
                <div
                  v-if="common.discount.type === 'Ticket'"
                  class="ticket-list"
                >
                  <div
                    v-for="(ticket) in common.discount.ticket.list"
                    :key="ticket.TicketInstanceId"
                    class="ticket"
                  >
                    <div class="ticket--left" />
                    <div class="ticket--right">
                      <div
                        slot="label"
                        class="content"
                      >
                        <p class="name">
                          {{ ticket.Name }}
                        </p>
                        <p class="date">
                          使用期限 {{ ticket.ValidDue }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="dialog-footer">
                <v-btn
                  v-if="!common.receivedCoupon || !common.successMessages.length"
                  class="btn"
                  btn-title="確認"
                  depressed
                  color="primary"
                  :loading="dialog.isLoading"
                  :disabled="dialog.isLoading"
                  @click="clickReceiveCoupon('common')"
                >
                  確認
                </v-btn>
                <v-btn
                  v-else
                  class="btn"
                  btn-title="完成"
                  depressed
                  color="primary"
                  @click="closeDialog"
                >
                  完成
                </v-btn>
              </div>
            </v-tab-item>
            <!-- 一般兌換tab /-->

            <!-- 企業夥伴兌換tab -->
            <v-tab-item class="receive-tab-content">
              <div class="receice-content content-wrap">
                <v-text-field
                  v-model="enterprise.couponSn"
                  label="請輸入企業夥伴優惠代碼"
                  single-line
                  outlined
                  :clearable="Boolean(enterprise.couponSn) && enterprise.couponSnFocus"
                  :success-messages="enterprise.successMessages"
                  :error-messages="enterprise.errorMessages"
                  type="text"
                  @focus="enterprise.couponSnFocus = true"
                  @blur="enterprise.couponSnFocus = false"
                  @click:clear="clearTextHandle('enterprise')"
                />
                <div
                  v-if="enterprise.receivedCoupon && enterprise.discount.type === 'Bonus'"
                  class="item"
                >
                  <img
                    src="~/assets/image/bonus.svg"
                    alt="紅利點數"
                  >
                  <div class="content">
                    <p class="desc">
                      恭喜您獲得<span class="enterprise-tag">企業夥伴紅利點數</span><span class="price">{{ enterprise.discount.bonus.total }}</span>點
                    </p>
                  </div>
                </div>
              </div>
              <div class="dialog-footer">
                <v-btn
                  v-if="!enterprise.receivedCoupon || !enterprise.successMessages.length"
                  class="btn"
                  btn-title="確認"
                  depressed
                  color="primary"
                  :loading="dialog.isLoading"
                  :disabled="dialog.isLoading"
                  @click="clickReceiveCoupon('enterprise')"
                >
                  確認
                </v-btn>
                <v-btn
                  v-else
                  class="btn"
                  btn-title="完成"
                  depressed
                  color="primary"
                  @click="closeDialog"
                >
                  完成
                </v-btn>
              </div>
            </v-tab-item>
            <!-- 企業夥伴兌換tab /-->
          </v-tabs-items>
        </v-tabs>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    open: Boolean
  },
  data () {
    return {
      isMobile: null,
      dialog: {
        open: false,
        isLoading: false
      },
      tabs: null,
      common: { // 一般兌換
        couponSn: null,
        couponSnFocus: false,
        successMessages: '',
        errorMessages: '',
        receivedCoupon: false,
        discount: {
          type: null,
          bonus: {
            total: 0
          },
          ticket: {
            list: [],
            value: {},
            index: null,
            got: false
          }
        }
      },
      enterprise: { // 企業夥伴兌換
        couponSn: null,
        couponSnFocus: false,
        successMessages: '',
        errorMessages: '',
        receivedCoupon: false,
        discount: {
          type: null,
          bonus: {
            total: 0
          }
        }
      }
    }
  },
  computed: {
  },
  watch: {
    open (val) {
      this.dialog.open = val
      if (val) {
        this.common.discount = {
          type: null,
          bonus: {
            total: 0
          },
          ticket: {
            list: [],
            value: {},
            index: null,
            got: false
          }
        }
        this.enterprise.discount = {
          type: null,
          bonus: {
            total: 0
          }
        }
        // 領取狀態重置
        const resetParams = {
          successMessages: '',
          errorMessages: '',
          receivedCoupon: false
        }
        this.common = { ...this.common, ...resetParams }
        this.enterprise = { ...this.enterprise, ...resetParams }
      }
    },
    'common.couponSn' (val) {
      if (this.common.errorMessages.length && val) {
        this.common.errorMessages = ''
      }
      if (this.common.successMessages.length && val) {
        this.common.successMessages = ''
        this.common.discount = {
          type: null,
          bonus: {
            total: 0
          },
          ticket: {
            list: [],
            value: {},
            index: null,
            got: false
          }
        }
      }
    },
    'enterprise.couponSn' (val) {
      if (this.enterprise.errorMessages.length && val) {
        this.enterprise.errorMessages = ''
      }
      if (this.enterprise.successMessages.length && val) {
        this.enterprise.successMessages = ''
        this.enterprise.discount = {
          type: null,
          bonus: {
            total: 0
          }
        }
      }
    }
  },
  mounted () {
    this.isMobile = screen.width <= 768
    this.dialog.open = this.open
  },
  methods: {
    closeDialog () {
      this.common.couponSn = null
      this.enterprise.couponSn = null
      this.$emit('close', this.common.receivedCoupon || this.enterprise.receivedCoupon)
    },
    clearTextHandle (exchangeType) {
      if (this[exchangeType].errorMessages.length) {
        this[exchangeType].errorMessages = ''
      }
      if (this[exchangeType].successMessages.length) {
        this[exchangeType].successMessages = ''
        if (exchangeType === 'enterprise') { // 企業夥伴兌換
          this.enterprise.discount = {
            type: null,
            bonus: {
              total: 0
            }
          }
        } else { // 一般兌換
          this.common.discount = {
            type: null,
            bonus: {
              total: 0
            },
            ticket: {
              list: [],
              value: {},
              index: null,
              got: false
            }
          }
        }
      }
      this[exchangeType].couponSn = ''
    },
    handleGift (gift, exchangeType) {
      console.log('handleGift')
      if (exchangeType === 'enterprise') { // 企業點數兌換 （只有點數 沒有票券）
        console.log('handleGift enterprise')
        this.enterprise.discount.type = 'Bonus'
        this.enterprise.discount.bonus.total = gift
      } else { // 一般兌換
        if (gift.GiftTypeId === 1) {
          this.common.discount.type = 'Ticket'
          this.common.discount.ticket.list = gift.ListTicket.map(ticket => {
            ticket.ValidDue = ticket.ValidDue ? this.$dayjs(new Date(ticket.ValidDue)).format('YYYY/MM/DD') : ''
            return ticket
          })
        } else if (gift.GiftTypeId === 2) {
          this.common.discount.type = 'Bonus'
          this.common.discount.bonus.total = gift.GiftBonus
        }
      }
    },
    showReceiveGiftErrorMsg (errorData, exchangeType) {
      if (exchangeType === 'enterprise') { // 企業夥伴兌換
        const errorMessage = () => {
          switch (errorData.ErrorMessage.Code) {
            case 404036:
              return '無效的優惠代碼，請確認後重新輸入'
            case 409003:
              return '此代碼已經被領取過囉！'
            default:
              return '禮物領取失敗！'
          }
        }
        this.enterprise.errorMessages = errorMessage()
      } else { // 一般兌換
        const errorMessage = () => {
          switch (errorData.ErrorMessage.Code) {
            case 411001:
            case 411002:
              return '無效的優惠代碼，請確認後重新輸入'
            case 411003:
              return '優惠尚未開放領取，請等待至指定時間再領取'
            case 411004:
              return '優惠已經停止領取囉，下回請早'
            case 411005:
              return '您已經領取過這個優惠，不能再領取囉'
            case 411006:
              return '慢一步了，優惠已經被領取完畢囉'
            default:
              return '禮物領取失敗！'
          }
        }
        this.common.errorMessages = errorMessage()
      }
    },
    async requestExchangeGift (guid, giftInfo) {
      const listTicketIdArray = giftInfo.map(ticket => {
        return ticket.Id
      })
      const requestData = {
        Guid: guid,
        ListTicketId: listTicketIdArray
      }
      try {
        const res = await this.$axios.post('/api/Gift/ExchangeOfficialGift', requestData)
        return Promise.resolve(res.data)
      } catch (error) {
        return Promise.reject(error)
      }
    },
    async clickReceiveCoupon (exchangeType) {
      console.log('clickReceiveCoupon')
      if (!this[exchangeType].couponSn) {
        this[exchangeType].errorMessages = '請輸入優惠代碼'
        return
      }
      this.dialog.isLoading = true
      try {
        if (exchangeType === 'enterprise') { // 企業點數兌換
          const { data } = await this.$axios.post('/api/Gift/ExchangeEnterpriseCoin', { Code: this.enterprise.couponSn })
          console.log('clickReceiveCoupon data', data)
          this.handleGift(data.Data.VoucherAmount, 'enterprise')
          this.enterprise.discount.type = 'Bonus'
        } else { // 一般兌換
          const { data } = await this.$axios.get('/api/Gift/GetOfficialGiftBySn', { params: { Sn: this.common.couponSn } })
          const gift = await this.requestExchangeGift(data.Data[0].Guid, data.Data[0].ListTicket)
          this.handleGift(gift.Data[0], 'common')
        }
        this[exchangeType].errorMessages = ''
        this[exchangeType].successMessages = '優惠領取成功！'
        this[exchangeType].receivedCoupon = true
        this.dialog.isLoading = false
      } catch (error) {
        console.log(error)
        this.dialog.isLoading = false
        this.showReceiveGiftErrorMsg(error.response.data, exchangeType)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-discount {
  .dialog-content {
    padding: 0;
    .content-wrap {
      margin: 20px 0;
    }
    .item {
      display: flex;
      align-items: flex-start;
      padding: 25px 5px 10px;
      img {
        flex: none;
        width: 27px;
        height: auto;
        margin-right: 10px;
      }
      .content {
        flex: 1;
        > p.label {
          font-weight: bold;
          font-size: pxTorem(16px);
          line-height: pxTorem(22px);
          margin-bottom: 10px;
        }
        .enterprise-tag {
          color: $mainColor;
        }
        .hidden {
          opacity: 0;
        }
        p {
          margin-bottom: 0;
        }
        .price {
          @include price;
          margin-left: 5px;
          font-size: pxTorem(17px);
          line-height: pxTorem(24px);
        }
      }
      .content {
        .desc {
          margin-bottom: 10px;
        }
        .hidden {
          opacity: 0;
        }
        .price {
          color: $errorColor;
          margin-right: 5px;
        }
      }
    }
    .ticket-list {
      .ticket {
        width: 100%;
        border: 1px solid #d2d2d2;
        border-radius: 4px;
        display: inline-flex;
        min-height: 115px;
        padding: 0;
        font-variant-numeric: tabular-nums;
        margin: 0;
        &--left {
          position: relative;
          flex: none;
          display: flex;
          justify-content: center;
          align-items: center;
          width: 95px;
          height: auto;
          padding: 5px;
          cursor: pointer;
        }
        &--right {
          .name {
            color: $fontColor;
          }
          .content {
            position: relative;
            padding: 12px;
            min-height: 115px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            p {
              margin-bottom: 0;
            }
          }
        }
      }
    }
  }
}
.dialog-card {
  height: 80vh;
  position: relative;
  overflow: hidden;
  .content-wrap {
    height: calc(80vh - 240px);
    text-align: left;
    overflow: auto;
  }
  .tabs {
    ::v-deep {
      .v-tabs-slider-wrapper {
        height: 4px !important;
      }
      .v-tabs-bar {
        border-bottom: 1px solid #d2d2d2;
      }
    }
    .v-tabs-bar {
      height: auto;
      .tab {
        color: $midGrayColor;
        font-weight: 400;
        font-size: pxTorem(17px);
        line-height: pxTorem(24px);
        &.v-tab--active {
          color: $mainColor;
          opacity: 1;
          font-weight: bold;
        }
      }
    }
  }
}

/** 手機 */
@media screen and (max-width: $mobileWidth) {
  .v-dialog {
    .v-card {
      .v-card__text {
        padding: 0 0 20px;
      }
    }
  }
  .dialog-card {
    .tabs {
      .v-tabs-bar {
        .tab {
          width: 50%;
        }
      }
    }
    .content-wrap {
      height: calc(100vh - 240px - var(--safe-area-inset-bottom) - var(--safe-area-inset-top));
    }
  }
  .dialog-footer {
    position: fixed;
    bottom: 20px;
    left: 50%;
    transform: translate(-50%, 0);

    .btn {
      width: 80vw;
      height: auto;
      padding: 14px;
    }
  }
}
/** 手機以上 */
@media screen and (min-width: $mobileWidth) {
  .dialog-card {
    .dialog-footer {
      position: fixed;
      left: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0;
      transform: translate(-50%, 0);
      .btn {
        height: auto;
        width: 135px;
        padding: 11px 0;
        font-size: pxTorem(16px);
      }
    }
    .empty-wrap {
      margin-top: 100px;
    }

  }
}
</style>
